import { UserPopover } from "@/components/Popover/User";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export default function UserMention({
    children,
}: { children: any }) {
    if (typeof children !== 'string') return null;
    const queryClient = useQueryClient();
    const { teamId } = useParams();
    const allTeamsMembers = queryClient.getQueriesData({
        predicate: (query) => query.queryKey[0] === "team" && query.queryKey[2] === "members"
    });
    const members = queryClient.getQueryState(["team", teamId, "members"]) as any;
    const userId = children?.slice(2, -1);
    const member = members?.data?.members?.find((member: any) => member.id === userId) || allTeamsMembers.map((team: any) => team[1]?.members?.find((member: any) => member.id === userId)).filter((member: any) => member)[0];
    const onThisTeam = members?.data?.members?.find((member: any) => member.id === userId);
    return (<>
        {member ? (
            <div className="inline-block align-middle">
                <UserPopover user={{
                    ...member,
                    ...(onThisTeam ? {} : { roles: ["leave"] })
                }}>
                    <div className="flex bg-brand-gray/70 px-2 rounded-full max-h-6 items-center cursor-pointer hover:bg-brand-gray/50">
                        {member?.profilePicture && (
                                <img src={member?.profilePicture} className="h-6 w-6 rounded-full" loading="lazy" />
                        ) || (
                                <div className="h-6 w-6 bg-brand-back rounded-full flex items-center justify-center">
                                    <p className="text-xs">{member?.username[0]}</p>
                                </div>
                            )}
                        <p className="font-medium ml-1">@{member?.username}</p>
                    </div>
                </UserPopover>
            </div>
        ) : (
            <div className="inline-block bg-brand-gray/70 px-1 rounded items-center hover:bg-brand-gray/50">
                <p className="font-medium">@invalid-user</p>
            </div>
        )}
    </>);
}